export default cells => (
  Object.values(cells)
);
